import axios from 'axios';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import type { XSubProcess } from '@/models/xsubprocess';

class XSubProcessWebservice {
    public load(xProcessId: number, approvalState: ApprovalState) {
        if (approvalState === ApprovalState.ALL) {
            return axios.get<XSubProcess[]>('/xsubprocesses', {
                params: {
                    xProcessId,
                },
            });
        } else {
            return axios.get<XSubProcess[]>('/xsubprocesses', {
                params: {
                    xProcessId,
                    approved: approvalState === ApprovalState.APPROVED ? 1 : 0,
                },
            });
        }
    }

    public filter(subProcessId: number, projectId: number) {
        return axios.get<XSubProcess[]>('/xsubprocesses/filter', {
            params: {
                subProcessId,
                projectId,
            },
        });
    }

    public getById(xSubProcessId: string) {
        return axios.get<XSubProcess>('/xsubprocesses/getById', {
            params: {
                xSubProcessId,
            },
        });
    }

    public store(subProcess: XSubProcess) {
        return axios.post('/xsubprocesses/store', {
            title: subProcess.title,
            description: subProcess.description,
            xProcessId: subProcess.x_process.id,
            order: subProcess.order, // No need for this
            abbreviation: subProcess.abbreviation, // No need for this
        });
    }

    public update(subProcess: XSubProcess) {
        return axios.post('/xsubprocesses/update', {
            id: subProcess.id,
            title: subProcess.title,
            description: subProcess.description,
            order: subProcess.order, // No need for this
            abbreviation: subProcess.abbreviation, // No need for this
        });
    }

    public remove(subProcess: XSubProcess) {
        return axios.post('/xsubprocesses/remove', {
            id: subProcess.id,
        });
    }
}

export const xSubProcessWebservice = new XSubProcessWebservice();
